(() => {
    // Early exit for subsite
    if (document.body.classList.contains("subsite")) return;

    /* ==========================================================================
       Back to Top Button
       ========================================================================== */
    const initBackToTop = () => {
        const thresholdNode = document.querySelector("main");
        if (!thresholdNode) return;

        // Kept as <div> to preserve your original CSS styles
        const btnWrapper = document.createElement("div");
        btnWrapper.id = "backtotop";
        btnWrapper.title = "Back to top";
        btnWrapper.style.display = "none";
        btnWrapper.innerHTML = '<img src="/img/backtotop.svg?v=2" alt="Back to top">';
        document.body.appendChild(btnWrapper);

        let isShown = false;

        // Toggle visibility based on scroll threshold
        const toggleButton = () => {
            const thresholdTop = thresholdNode.getBoundingClientRect().top + window.scrollY;
            const shouldShow = window.scrollY > thresholdTop;

            if (shouldShow !== isShown) {
                isShown = shouldShow;
                // Clearing style.display lets your CSS stylesheet control the visible state
                btnWrapper.style.display = isShown ? "" : "none";
            }
        };

        // Scroll listener with passive flag for performance
        window.addEventListener("scroll", toggleButton, { passive: true });

        // Scroll to top action
        btnWrapper.addEventListener("click", () => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
    };

    /* ==========================================================================
       Anchor Offsets
       ========================================================================== */
    const applyAnchorOffset = (href) => {
        if (!href) return;

        const hashIndex = href.indexOf("#");
        if (hashIndex === -1) return;

        const targetId = href.slice(hashIndex);
        if (targetId === "#") return;

        const target = document.querySelector(targetId);
        if (target) {
            target.style.scrollMarginTop = window.innerWidth > 1200 ? "150px" : "0px";
        }
    };

    /* ==========================================================================
       Initialization
       ========================================================================== */
    const init = () => {
        initBackToTop();

        // Apply anchor scroll on initial load
        applyAnchorOffset(window.location.href);

        // Event delegation for grid links
        document.addEventListener("click", (event) => {
            const link = event.target.closest(".grid a");
            if (link) {
                applyAnchorOffset(link.href);
            }
        });
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();